module.exports = __webpack_public_path__ + "img/YN60.png";